// @ts-nocheck
// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 用户名登录 POST /api/open/v1/access/login/username */
export async function postOpenV1AccessLoginUsername(
  body: API.AccessLoginWithUsernameReq,
  options?: { [key: string]: any }
) {
  return request<API.AccessLoginWithUsernameRes>(
    "/api/open/v1/access/login/username",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 用户登出 POST /api/open/v1/access/logout */
export async function postOpenV1AccessLogout(
  body: API.AccessLogoutReq,
  options?: { [key: string]: any }
) {
  return request<API.AccessLogoutRes>("/api/open/v1/access/logout", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 验证码校验 POST /api/open/v1/captcha/check */
export async function postOpenV1CaptchaCheck(
  body: API.CaptchaCheckReq,
  options?: { [key: string]: any }
) {
  return request<API.CaptchaCheckRes>("/api/open/v1/captcha/check", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 验证码获取 GET /api/open/v1/captcha/get */
export async function getOpenV1CaptchaGet(options?: { [key: string]: any }) {
  return request<API.CaptchaGetRes>("/api/open/v1/captcha/get", {
    method: "GET",
    ...(options || {}),
  });
}

/** 获取图标 GET /api/open/v1/config/icon */
export async function getOpenV1ConfigIcon(options?: { [key: string]: any }) {
  return request<API.ConfigIconRes>("/api/open/v1/config/icon", {
    method: "GET",
    ...(options || {}),
  });
}

/** 获取配置项 GET /api/open/v1/config/items */
export async function getOpenV1ConfigItems(options?: { [key: string]: any }) {
  return request<API.ConfigItemsRes>("/api/open/v1/config/items", {
    method: "GET",
    ...(options || {}),
  });
}
